import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { ApiService } from '../services/api.service';
import { UtilService } from '../services/util.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private _authService: AuthService,
        private _api: ApiService,
        private util: UtilService
    ) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((err) => {
                if (err.status === 401) {
                    this.router.navigateByUrl('/auth/signin');
                    this._api.isLogginFirstTime.next(false);
                    this._authService.signOut();
                }
                if (err.status === 500) {
                    if (
                        err.error.exception ==
                            'Stancl\\Tenancy\\Exceptions\\TenantCouldNotBeIdentifiedOnDomainException' ||
                        err.error.exception ==
                            'Stancl\\Tenancy\\Exceptions\\NotASubdomainException'
                    ) {
                        window.location.href = 'https://partnerReach.ai/';
                        return;
                    } else if (
                        err.error.exception ==
                        'Stancl\\Tenancy\\Exceptions\\TenantCouldNotBeIdentifiedByRequestDataException'
                    ) {
                        this.router.navigateByUrl('/auth/signin');
                        this._api.isLogginFirstTime.next(false);
                        this._authService.signOut();
                    } else {
                        this.router.navigateByUrl('/500');
                        this.util.showToast('Internal server error.', true);
                    }
                }
                if (err.status === 422) {
                    return throwError(
                        err.error.errors ? err.error.errors : err.error
                    );
                }

                if (err.status === 400) {
                    this._api.checkSubscriotion.next(false);
                    this._api.isSubscriptionOver.next(true);
                    this.router.navigateByUrl('/manage/subscription');
                }

                if (err.status === 403 && err?.error?.message) {
                   this.util.showToast(err?.error?.message, true);
                }   
                const error =
                    err.error.error || err.error.message || err.statusText;
                return throwError(error);
            })
        );
    }
}
